import React, { useState } from 'react';
import Index from './Components/Index'



function App() {


  return (
    <div className="App">
      <Index />
    </div>
  );
}

export default App;
